import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import CustomizedCheckboxOption from "../CustomizedCheckboxOption";
import CustomValueContainer from "../CustomeValueContainer";
import API from "../../../services/api.jsx";

export const SELECT_ALL_KEY = 'select-all';
export const SELECT_ALL_LABEL = 'All';

const MultiSelectField = ({
  value = [],
  onChange,
  options: initialOptions = [],
  optionKey,
  className,
  classNamePrefix,
  placeholder,
  required,
  disabled,
}) => {
  const [options, setOptions] = useState(initialOptions);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const hasLoadedOptions = useRef(false);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (optionKey && !hasLoadedOptions.current) {
      hasLoadedOptions.current = true;
      API.getAvaliableOptions(optionKey).then((response) => {
        const formattedOptions = response[optionKey].map(item => ({
          key: item.id,
          label: item.name
        }));
        setOptions(formattedOptions);
      });
    } else if (!optionKey) {
      setOptions(initialOptions);
    }
  }, [optionKey, initialOptions]);

  useEffect(() => {
    if (optionKey === 'affiliates' && !hasInitialized.current) {
      if (options.length === 1 && !value.length) {
        onChange([options[0].key]);
        hasInitialized.current = true;
      } else if (options.length > 1 && !value.length) {
        setIsAllSelected(true);
        onChange([]);
        hasInitialized.current = true;
      }
    }
  }, [options, optionKey]); 

  const selectedOptions = value
    ? options?.filter((i) => value.includes(i.key))
    : [];

  const handleChange = (e) => {
    const hasSelectAll = e?.some(option => option.key === SELECT_ALL_KEY);
    const wasAllSelected = isAllSelected;
    const isDeselectingSelectAll = wasAllSelected && !hasSelectAll;

    if (hasSelectAll && !wasAllSelected) {
      // If select all, return empty array but keep the display
      setIsAllSelected(true);
      onChange([]);
    } else if (isDeselectingSelectAll) {
      // If deselect all, clear all selection
      setIsAllSelected(false);
      onChange([]);
    } else {
      // Normal selection logic
      setIsAllSelected(false);
      const val = e?.length > 0
        ? e.filter(option => option.key !== SELECT_ALL_KEY).map(i => i.key)
        : [];
      onChange(val);
    }
  };

  return (
    <Select
      isMulti
      closeMenuOnSelect={true}
      hideSelectedOptions={false}
      disabled={disabled}
      className={`default-selector ${className || ""}`}
      classNamePrefix={classNamePrefix || "default-selector"}
      placeholder={placeholder}
      required={required}
      value={
        isAllSelected
          ? [
              { key: SELECT_ALL_KEY, label: SELECT_ALL_LABEL },
              ...options
            ]
          : selectedOptions
      }
      options={
        options.length > 1
          ? [
              { key: SELECT_ALL_KEY, label: SELECT_ALL_LABEL },
              ...options,
            ]
          : options
      }
      getOptionLabel={(entity) => entity.label}
      getOptionValue={(entity) => entity.key}
      onChange={handleChange}
      components={{
        Option: CustomizedCheckboxOption,
        ValueContainer: CustomValueContainer,
        IndicatorsContainer: () => (
          <div className="default-selector__indicator">
            <i className="icon-plus" />
          </div>
        ),
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          width: 204,
        }),
      }}
    />
  );
};

export default MultiSelectField;
